import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authSlice, { logout } from './slices/authSlice';
import chatSlice from './slices/chatSlice';
import uiSlice from './slices/uiSlice';
import channelSlice from './slices/channelSlice';
import userSlice from './slices/userSlice';
import taskSlice from './slices/taskSlice';
import spaceSlice from './slices/spaceSlice';
import savedMessageSlice from './slices/savedMessageSlice';
import panelAccessSlice from './slices/panelAccessSlice';
import meetingNotificationSlice from './slices/meetingNotificationSlice';
import userNotificationSlice from './slices/userNotificationSlice';
import workflowCatalogSlice from './slices/workflowCatalogSlice';
import liveTrackingSlice from './slices/liveTrackingSlice';

const appReducer = combineReducers({
  auth: authSlice,
  chat: chatSlice,
  ui: uiSlice,
  channels: channelSlice,
  users: userSlice,
  tasks: taskSlice,
  spaces: spaceSlice,
  savedMessages: savedMessageSlice,
  panelAccess: panelAccessSlice,
  meetingNotifications: meetingNotificationSlice,
  userNotifications: userNotificationSlice,
  workflowCatalog: workflowCatalogSlice,
  liveTracking: liveTrackingSlice,
});

export const rootReducer = (state, action) => {
  if (logout.fulfilled.match(action)) {
    const ui = state?.ui;
    state = ui !== undefined ? { ui } : undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
